import React from 'react'

type Props = {
  className?: string
}

const LoadingSkeleton = ({ className = '' }: Props) => {
  return <div className={`h-28 animate-pulse rounded-2xl bg-grey-200 ${className}`} />
}

export default LoadingSkeleton
